<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const router = useRouter();
const { accountId } = useAccount();

const goBackToInboxes = () => {
  router.push({
    name: 'settings_inbox_list',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="overflow-auto col-span-6 p-6 w-full h-full max-w-2xl">
    <PageHeader
      header-title="Voice (FreeSWITCH & WebRTC)"
      header-content="Telephony lines, DIDs, and SIP trunks are provisioned and managed directly by your system administrator."
    />

    <div class="mt-6 flex flex-col gap-5 p-6 rounded-2xl bg-n-solid-1 border border-n-weak">
      <div class="flex items-start gap-4">
        <div class="flex items-center justify-center size-12 rounded-2xl bg-n-teal-3 text-n-teal-11 shrink-0">
          <Icon icon="i-woot-voice" class="size-6" />
        </div>
        <div class="flex flex-col gap-1">
          <h3 class="text-base font-semibold text-n-slate-12">
            FreeSWITCH Telephony Line
          </h3>
          <p class="text-sm text-n-slate-11 leading-relaxed">
            Your FreeSWITCH SIP Trunk and WebRTC calling line are provisioned automatically on your account. Inbound phone calls and outbound dialpad routing use this integrated telephony trunk.
          </p>
        </div>
      </div>

      <div class="flex items-center justify-between pt-4 border-t border-n-weak">
        <span class="text-xs font-medium text-n-teal-11 flex items-center gap-1.5">
          <span class="size-2 rounded-full bg-n-teal-9 animate-pulse" />
          System Managed Telephony
        </span>

        <NextButton
          label="Back to Inboxes"
          type="button"
          class="!rounded-xl"
          @click="goBackToInboxes"
        />
      </div>
    </div>
  </div>
</template>
